export default __webpack_public_path__ + "static/media/cw.d282ddea.svg";